module.exports = __webpack_public_path__ + "media/images/common/h3_deadline-6ba611f24862011c6829fa08209fed39.gif";